import { render } from "./ClientRemindersList.vue?vue&type=template&id=3835e005&scoped=true"
import script from "./ClientRemindersList.vue?vue&type=script&lang=js"
export * from "./ClientRemindersList.vue?vue&type=script&lang=js"

import "./ClientRemindersList.vue?vue&type=style&index=0&id=3835e005&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3835e005"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField,QItemLabel});
